/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    29/07/2018
 */
export class Sector {
    public id: string;
    public name: string;
}



// WEBPACK FOOTER //
// ./src/lemsar/common/domains/models/sector.ts